import { makeStyles } from "@material-ui/styles";

const gameFinalizeStyles = makeStyles((theme) => ({
	container: {
		margin: "auto",
		display: "flex",
		padding: theme.spacing(2)
	},
	attendance: {
		marginTop: 18
	},
	timeGroup: {
		justifyContent: "space-between",
		flexDirection: "row"
	}
}));

export default gameFinalizeStyles;
